import { defineAppConfig } from '#imports';
import { NETWORK_NAME } from '~/service/EVM/config';

export default defineAppConfig({
    links: {
        social: {
            termsOfUse: `${import.meta.env.VITE_DOMEN_URL}/docs`,
            privacyPolicy: 'https://gmbzrmarketplace.gitbook.io/gmbzr-privacy-policy'
        }
    } as const,
    collection: {
        pagination: {
            initialPage: 1,
            initialSize: 10,
            maxSize: 100,
            maxPage: 9999
        },
        sort: {
            initialSorting: 'name',
            initialDirection: 'asc'
        },
        initialWatchListTab: 'Top'
    } as const,
    profile: {
        pagination: {
            initialPage: 1,
            initialSize: 10,
            maxSize: 100,
            maxPage: 9999
        },
        sort: {
            initialDirection: 'asc'
        }
    },
    tokenSlugOffers: {
        pagination: {
            initialPage: 1,
            initialSize: 10,
            maxSize: 100,
            maxPage: 9999
        },
        sort: {
            initialDirection: 'asc'
        }
    } as const,
    collectionSlug: {
        pagination: {
            initialPage: 1,
            initialSize: 20,
            maxSize: 100,
            maxPage: 9999
        },
        sort: {
            initialSorting: 'price',
            initialDirection: 'asc'
        }
    } as const,
    filter: {
        networks: [
            {
                value: NETWORK_NAME.MAINNET,
                label: '',
                icon: {
                    name: 'etherium',
                    size: 24
                }
            },
            {
                value: NETWORK_NAME.POLYGON,
                label: '',
                icon: {
                    name: 'polygon',
                    size: 24
                }
            },
            {
                value: NETWORK_NAME.XSOLLA_ZK,
                label: '',
                icon: {
                    name: 'XSOLLAZK',
                    size: 24
                }
            }
        ],
        priceCurrency: {
            [NETWORK_NAME.MAINNET]: {
                value: NETWORK_NAME.MAINNET,
                label: 'ETH'
            },
            [NETWORK_NAME.POLYGON]: {
                value: NETWORK_NAME.POLYGON,
                label: 'POL'
            },
            [NETWORK_NAME.XSOLLA_ZK]: {
                value: NETWORK_NAME.XSOLLA_ZK,
                label: 'ETH'
            }
        }
    } as const
});
